module.exports = __webpack_public_path__ + "img/next.2a07af42.png";